
import TableList from "@components/templates/tablelist";
import { HttpGetErrorStorageList,HttpReprocrssBtn } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";

import mixin from '../mixin'

export default {
    mixins: [TableList,mixin],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },

    methods: {
        interceptRequest(params) {
            const { BT_periodDate,EQ_billStatus } = params.search;
            params.periodDate = BT_periodDate;
            params.billStatus = EQ_billStatus;

            delete params.search.BT_periodDate;
            delete params.search.EQ_billStatus;
            this.formData = params
            return params
        },
        ajaxRequest: HttpGetErrorStorageList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "revoke":
                    this.operate={
                        show: true,
                        alert: "warning",
                        params:{ids:params, costType:4},
                        title: "重处理",
                        ajaxRequest:HttpReprocrssBtn
                    }
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingReceivableStorageItem/export", {"search[EQ_hostOrganizationId]":global.SYSID,
                        "search[EQ_status]":3,...this.formData},
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    );
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "重处理",
                    operate: "revoke",
                    theme:"warning",
                    batch:true,
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    options: this.getBillcusWareList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '项目',
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                },

                {
                    label: 'SKU',
                    tag: 'vInput',
                    key: 'EQ_sku',
                    show: true,
                },
                {
                    label: '库存类型',
                    tag: 'vSelect',
                    key: 'EQ_inventoryType',
                    options: [
                        {value:0,label:'可售库存'},
                        {value:1,label:'不可售库存'}
                    ],
                    props:{
                        filterable:true,
                    },
                },

                {
                    label: '批次号',
                    tag: 'vInput',
                    key: 'EQ_batchNo',
                },
                {
                    label: '快照日期',
                    tag: 'vDatepicker',
                    key: 'BT_fetchDate',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    show: true,
                },
                {
                    label: '异常日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },


            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '组织',
                    render:(h,{row})=>{
                        return <div>{row.organizationName}</div>
                    }
                },
                {
                    title: '仓库',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.warehouseId),
                },
                {
                    title: '项目',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId) || '--',
                },
                {
                    title: 'sku',
                    render: (h, { row }) => {
                        return <div>{row.sku || '--'}</div>
                    }
                },
                {
                    title: '库存类型',
                    render: (h, { row }) => {
                        return <div>{row.inventoryType == 0 ? '可售库存':'不可售库存' || '--'}</div>
                    }
                },

                {
                    title: '库存快照日期',
                    render: (h, { row }) => {
                        return <div>{row.fetchDate || '--'}</div>
                    }
                },
                {
                    title: '批次号',
                    render: (h, { row }) => {
                        return <div>{row.batchNo || '--'}</div>
                    }
                },
                {
                    title: '异常原因',
                    render: (h, { row }) => {
                        return <div>{row.exceptionMsg || '--'}</div>
                    }
                },

                {
                    title: '异常时间',
                    render: (h, { row }) => {
                        return <div>{row.createdAt || '--'}</div>
                    }
                },
            ];
        },

    },

};
